import { render, staticRenderFns } from "./redEnvelope.vue?vue&type=template&id=37503759&scoped=true&"
import script from "./redEnvelope.vue?vue&type=script&lang=js&"
export * from "./redEnvelope.vue?vue&type=script&lang=js&"
import style0 from "./redEnvelope.vue?vue&type=style&index=0&id=37503759&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37503759",
  null
  
)

export default component.exports